var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "_") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.84,110.33A14.85,14.85,0,0,1,0,95.49L6.6,9.67H36.29l-6.62,86A14.82,14.82,0,0,1,14.84,110.33ZM10.18,13.54,3.86,95.63a11,11,0,0,0,22-.14L32.1,13.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.17,110.33H14.84v-3.87h90.33a11,11,0,0,0,11-11l-6.31-81.95H27.74V9.67h85.67L120,95.34A14.88,14.88,0,0,1,105.17,110.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.91,81.29A21.3,21.3,0,0,1,51.62,60V43.87h3.87V60a17.42,17.42,0,0,0,34.84,0V43.87H94.2V60A21.31,21.31,0,0,1,72.91,81.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.55,45.8a5.16,5.16,0,1,1,5.16-5.16A5.16,5.16,0,0,1,53.55,45.8Zm0-6.45a1.29,1.29,0,0,0-1.29,1.29c0,1.43,2.58,1.43,2.58,0A1.29,1.29,0,0,0,53.55,39.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.26,45.8a5.16,5.16,0,1,1,5.16-5.16A5.17,5.17,0,0,1,92.26,45.8Zm0-6.45A1.29,1.29,0,0,0,91,40.64c0,1.43,2.59,1.43,2.59,0A1.3,1.3,0,0,0,92.26,39.35Z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 8.39,
    y: 22.58,
    width: 103.23,
    height: 3.87
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlour);
export default __webpack_public_path__ + "static/media/flour.3aedfb54291fc4bb2d410e4133dc6e7d.svg";
export { ForwardRef as ReactComponent };